import { render, staticRenderFns } from "./rSelectOtro.vue?vue&type=template&id=67d870ae&scoped=true"
import script from "./rSelectOtro.vue?vue&type=script&lang=js"
export * from "./rSelectOtro.vue?vue&type=script&lang=js"
import style0 from "./rSelectOtro.vue?vue&type=style&index=0&id=67d870ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d870ae",
  null
  
)

export default component.exports